import React from 'react';
import { TweenLite } from 'gsap';
import classNames from 'classnames';

import IconClose from 'components/assets/icon-close.svg';

import s from './NotificationBar.module.scss';

type Props = {
  color: string;
  children: React.ReactNode;
  onClose?: () => void;
};

export const NotificationBar = ({ color, children, onClose }: Props) => {
  const barEl = React.useRef<HTMLDivElement | null>(null);
  const containerEl = React.useRef<HTMLDivElement | null>(null);
  const [animateOut, setAnimateOut] = React.useState(false);

  React.useEffect(() => {
    const height = containerEl.current?.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty('--notification-height', `${height / 10}rem`);
  }, []);

  // Animate out
  React.useEffect(() => {
    if (!!animateOut) {
      document.documentElement.style.setProperty('--notification-height', '0rem');
      TweenLite.to(barEl.current, 0.3, {
        height: 0,
        duration: 0.3,
        onComplete: () => {
          onClose && onClose();
        },
      });
    }
  }, [animateOut]);

  const barColor = color.toLowerCase() || 'black';

  return (
    <div ref={barEl} className={classNames(s.bar, s[barColor])}>
      <div ref={containerEl} className={s.bar__container}>
        <div className={s.bar__message}>{children}</div>
        <button className={s.bar__close} onClick={() => setAnimateOut(true)}>
          <IconClose />
        </button>
      </div>
    </div>
  );
};
